<mat-progress-bar mode="indeterminate" style="width: 200px"></mat-progress-bar>
<div style="text-align: center; padding-top: 10px">{{data.message}}</div>
